import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

import {ErrorResponse} from '../../../../data/model/errorResponse';
import {OrganisationsDataManager} from '../../../../data/organisations.datamanager';
import {UploadDataManager} from '../../../../data/upload.datamanager';

@Component({
  selector: 'edit-organisation-dialog',
  templateUrl: './edit-organisation-dialog.html'
})
export class EditOrganisationDialogComponent {
  value = 0;
  showProgress = false;
  image: File = null;
  statusText = 'starting upload';
  amountInput = new FormControl(
      '', [Validators.pattern('^[0-9]*$'), Validators.required]);
  nameInput = new FormControl('', [Validators.required]);
  administratorMailAddressInput = new FormControl('', [Validators.required]);

  constructor(
      public dialogRef: MatDialogRef<EditOrganisationDialogComponent>,
      private uploadDataManager: UploadDataManager,
      private organisationsDataManager: OrganisationsDataManager,
      @Inject(MAT_DIALOG_DATA) public data: any) {}

  getErrorMessage() {
    return this.amountInput.hasError('required') ?
        'You must enter an amount' :
        this.amountInput.hasError('pattern') ? 'Not a valid number' : '';
  }
  onAddClick(data) {
    if (this.image === null) {
      this.organisationsDataManager.updateOrganisation(data.organisation)
          .subscribe(
              (res) => {
                this.closeDialogSuccess('succesfully updated the organisation');
              },
              (err) => {
                console.log(err);
                this.closeDialogWithError(err.json());
              });
    }
    if (this.image !== null) {
      this.statusText = 'Uploading image';
      this.value = 0;
      this.uploadDataManager.getSignedUpload(this.image.name, this.image.type)
          .subscribe(
              (imageSignedResponse) => {
                this.uploadDataManager
                    .uploadFileToS3(imageSignedResponse, this.image)
                    .subscribe(
                        (imageResponse) => {
                          if (typeof imageResponse === 'string') {
                            this.data.organisation.logo_image_url =
                                imageSignedResponse.url;
                            this.organisationsDataManager
                                .updateOrganisation(data.organisation)
                                .subscribe(
                                    (res) => {
                                      this.closeDialogSuccess(
                                          'succesfully updated the organisation');
                                    },
                                    (err) => {
                                      console.log(err);
                                      this.closeDialogWithError(err.json());
                                    });
                          } else {
                            this.value = imageResponse;
                          }
                        },
                        (err) => {
                          console.log(err);
                          this.closeDialogWithError(err.json());
                        });
              },
              (err) => {
                console.log(err);
                this.closeDialogWithError(err.json());
              });
    }
  }

  handleImageInput(files: FileList) {
    this.image = files.item(0);
  }

  openImageUpload() {
    document.getElementById('image-id').click();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  closeDialogWithError(error: ErrorResponse) {
    this.dialogRef.close(error);
  }

  closeDialogSuccess(message: string) {
    this.dialogRef.close(message);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/organisations/edit/edit.organisation.dialog.component.ts